import { BUNNY_FRAME_A, BUNNY_FRAME_B } from "@/code/bunny_frames";

/**
 * The jumping ASCII bunny, built with plain DOM.
 *
 * Same markup and same `.bq-bunny-*` classes as components/bunnyLoader.vue, so
 * the two animate identically. It is duplicated in plain DOM rather than
 * mounted as a Vue component because fullScreenLoader() runs inside a router
 * guard, before the target route's component exists -- and, on the very first
 * navigation, before the Vue app is mounted at all.
 *
 * The CSS deliberately lives in assets/less/main.less (the entry stylesheet)
 * rather than in the SFC: a lazy route chunk's CSS has not loaded yet at this
 * point, so component-scoped rules would arrive after the frames had already
 * painted unstyled.
 */
export function bunnyLoaderEl(label?: string): HTMLElement {
    const root = document.createElement("div");
    root.className = "bq-bunny-loader";
    root.setAttribute("aria-hidden", "true");
    root.setAttribute("translate", "no");

    const stage = document.createElement("div");
    stage.className = "bq-bunny-stage";
    const track = document.createElement("div");
    track.className = "bq-bunny-track";
    const dir = document.createElement("div");
    dir.className = "bq-bunny-dir";

    const frameA = document.createElement("pre");
    frameA.className = "bq-frame bq-frame-a";
    frameA.setAttribute("translate", "no");
    frameA.textContent = BUNNY_FRAME_A;

    const frameB = document.createElement("pre");
    frameB.className = "bq-frame bq-frame-b";
    frameB.setAttribute("translate", "no");
    frameB.textContent = BUNNY_FRAME_B;

    dir.appendChild(frameA);
    dir.appendChild(frameB);
    track.appendChild(dir);
    stage.appendChild(track);
    root.appendChild(stage);

    if (label) {
        const labelEl = document.createElement("div");
        labelEl.className = "bq-bunny-loader__label";
        labelEl.textContent = label;
        root.appendChild(labelEl);
    }

    return root;
}

export function fullScreenLoader() {
    // 이미 존재하면 다시 만들지 않음
    if (document.getElementById("full-screen-loader")) {
        return document.getElementById("full-screen-loader")!;
    }

    const loader = document.createElement("div");
    loader.id = "full-screen-loader";
    loader.style.position = "fixed";
    loader.style.top = "0";
    loader.style.left = "0";
    loader.style.width = "100%";
    loader.style.height = "100%";
    // Theme-aware overlay: 85% of the active @paper token so the loader
    // dims the page on both light and dark themes without washing out the
    // rabbit (which uses @ink).
    loader.style.backgroundColor =
        "color-mix(in srgb, var(--bq-paper) 85%, transparent)";
    loader.style.display = "flex";
    loader.style.flexDirection = "column";
    loader.style.justifyContent = "center";
    loader.style.alignItems = "center";
    loader.style.zIndex = "9999";
    loader.style.pointerEvents = "all";

    loader.appendChild(bunnyLoaderEl());
    loader.setAttribute("translate", "no");

    if (document.body) {
        return document.body.appendChild(loader);
    } else {
        // body가 없으면 html에 직접 추가
        return document.documentElement.appendChild(loader);
    }
}

export function removeFullScreenLoader() {
    const loaderElement = document.getElementById("full-screen-loader");
    if (loaderElement) {
        document.body.removeChild(loaderElement);
    }
}

// export function showDropDown(e) {
//     let getCustomSelect = document.getElementsByClassName("customSelect");
//     let currentTarget = e.currentTarget;
//     for (let i = 0; i < getCustomSelect.length; i++) {
//         if (currentTarget.isEqualNode(getCustomSelect[i])) {
//             continue;
//         }

//         let getMoreVert = getCustomSelect[i].lastChild;
//         getMoreVert.style.display = "none";
//     }

//     let getMoreVert = currentTarget.lastChild;
//     if (getMoreVert.style.display === "none") {
//         getMoreVert.style.display = "block";
//     } else {
//         getMoreVert.style.display = "none";
//     }
// };

// let hideMoreVert = (e) => {
//     let getMoreVert = document.getElementsByClassName("moreVert");

//     for (let i = 0; i < getMoreVert.length; i++) {
//         if (
//             getMoreVert[i].style.display == "block" &&
//             !getMoreVert[i].contains(e.target)
//         ) {
//             getMoreVert[i].style.display = "none";
//         }
//     }
// };

// document.addEventListener("click", hideMoreVert);
